import React from 'react';
import styled from '@nykaa/ui-components/styles/styled';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';
import { variantTypes } from '@nykaa/product-card-shared/constant/variants';
const Title = styled.div `
  overflow: hidden;
  ${({ theme, isNewPlp }) => (isNewPlp ? theme.typography.type120 : theme.typography.bodyMedium)};
  margin-bottom: ${({ theme }) => theme.spacing.spacing10};
  color: ${({ theme }) => theme.colors.textPrimary};
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  display: -webkit-box;
  word-break: break-all;
`;
const BrandName = styled.div `
  color: ${({ theme }) => hexToRgb(theme.colors.textPrimary, 0.92)};
  ${({ theme }) => theme.typography.type142};
  letter-spacing: 0.1px;
  line-height: 16px;
  margin-bottom: ${({ theme }) => theme.spacing.spacing10};
  margin-top: ${({ theme }) => theme.spacing.spacing20};
  overflow: hidden;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const CardTitle = ({ title, brandName, isNewPlpExpEnabled = false, variantType, productTitle, }) => {
    const updatedVariantType = variantType === null || variantType === void 0 ? void 0 : variantType.toUpperCase();
    if (isNewPlpExpEnabled && brandName && updatedVariantType !== variantTypes.BUNDLE && productTitle) {
        return (React.createElement(React.Fragment, null,
            React.createElement(BrandName, null, brandName),
            React.createElement(Title, { isNewPlp: true }, productTitle)));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Title, null, title)));
};
export default CardTitle;
